module.exports = __webpack_public_path__ + "img/3.77d6d2e2.png";